import { ReactNode } from "react";
import styled from "styled-components/macro";
import classNames from "classnames";
import { THEME_COLOR } from "../vars";
import { mix, darken } from "polished";

const BarContainer = styled.div`
  height: 26px;
  border-radius: 100px;
  width: 100%;
  margin: 0px 0;
  margin-bottom: 20px; /* for the text under the bar */
  background: #f8f8f8;
  box-shadow: 0 0 0 1px #ddd inset;
  & > .value {
    background: ${THEME_COLOR};
    height: 100%;
    border-radius: 100px;
    position: relative;
    min-width: 26px;
    &.red {
      background: #f83246;
    }
    & > .text {
      white-space: nowrap;
      position: absolute;
      top: 100%;
      color: grey;
      font-size: 12px;
      &.left {
        right: 0;
        &:after {
          content: " ▲ ";
          display: inline-block;
          transform: translateX(8px) scale(0.8);
        }
      }
      &.right {
        left: 100%;
        &:before {
          content: " ▲ ";
          display: inline-block;
          transform: translateX(-8px) scale(0.8);
        }
      }
    }
  }
`;

export default function Bar({
  used,
  max,
  percent,
  children,
}: {
  used: number;
  max: number;
  percent: number;
  children?: ReactNode;
}) {
  function formatNumber(num: number) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  }

  const isRed = percent > 90;
  return (
    <BarContainer>
      <div
        className={classNames("value", { red: isRed })}
        style={{ width: `${Math.min(100, percent)}%` }}
      >
        <div
          style={{ color: "#676163", marginTop: "2px" }}
          className={classNames("text", {
            right: percent <= 50,
            left: percent > 50,
          })}
        >
          Used {formatNumber(used)} (of {formatNumber(max)}) {children}
        </div>
      </div>
    </BarContainer>
  );
}

export function BarLite({
  name,
  used: number,
  max: target,
  label,
}: {
  name: string;
  used: number;
  max: number;
  label: string;
}) {
  const percent = (number / target) * 100;
  const color = percent >= 90 ? "#f83246" : THEME_COLOR;
  return (
    <BarLiteContainer>
      <BarValueContainer>
        <BarName>
          {name}
          <BarStat>
            {number.toLocaleString()} of {target.toLocaleString()} {label}
          </BarStat>
        </BarName>
        <BarValue
          style={{
            width: percent + "%",
            backgroundColor: mix(0.3, "#fff")(color),
            color: darken(0.5, color),
          }}
        >
          <BarName aria-hidden="true">
            {name}
            <BarStat>
              {number.toLocaleString()} of {target.toLocaleString()} {label}
            </BarStat>
          </BarName>
        </BarValue>
      </BarValueContainer>
    </BarLiteContainer>
  );
}

const BarLiteContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

const BarName = styled.div`
  font-weight: 500;
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  white-space: nowrap;
`;
const BarStat = styled.div`
  font-size: 0.8em;
  display: inline-block;
  margin-left: 10px;
`;

const BarValueContainer = styled.div`
  flex: 1;
  height: 20px;
  position: relative;
  background: #f5f5f7;
  /* background: #fff; */
  box-shadow: 0px 0px 0px 1px #00000011 inset;
  overflow: hidden;
  border-radius: 100px;
  color: #00000066;
`;

const BarValue = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 100px;
  background: ${THEME_COLOR};
  overflow: hidden;
  color: white;
  box-shadow: 0px 0px 0px 1px #00000011 inset;
`;
